import {
  fetchSourcePatient,
  getDoiTuong,
  getListBuongSo,
  getListDanhMucGiuongBenh,
  getListKhuKham,
  getListLoaiKCB,
  getListPhongKham,
  getListTTBH,
  getListTrangThaiCSKH,
  getListTrangThaiPhauThuat,
  getListTrangThaiPhieu,
  getListTrangThaiTraThuoc,
  getLitGroup,
} from "helper/call-api-list";

const CheckNullApi = () => {
  const khuKham = localStorage.getItem("khuKham");
  const TTBH = localStorage.getItem("TTBH");
  const TTPhieu = localStorage.getItem("TTPhieu");
  const phongKhamNoPeople = localStorage.getItem("phongKhamNoPeople");
  const phongKhamYesPeople = localStorage.getItem("phongKhamYesPeople");
  const TTPhauThuat = localStorage.getItem("TTPhauThuat");
  const TTCSKH = localStorage.getItem("TTCSKH");
  const doiTuong = localStorage.getItem("doiTuong");
  const nguonBN = localStorage.getItem("nguonBN");
  const TTTraThuoc = localStorage.getItem("TTTraThuoc");
  const loaiKCB = localStorage.getItem("loaiKCB");
  const tenDoan = localStorage.getItem("tenDoan");
  const tenPhong = localStorage.getItem("phong");
  const tenGiuong = localStorage.getItem("giuong");

  if (!khuKham) {
    getListKhuKham();
  }
  if (!TTBH) {
    getListTTBH();
  }
  if (!TTPhieu) {
    getListTrangThaiPhieu();
  }
  if (!phongKhamNoPeople || !phongKhamYesPeople) {
    getListPhongKham();
  }
  if (!TTPhauThuat) {
    getListTrangThaiPhauThuat();
  }
  if (!TTCSKH) {
    getListTrangThaiCSKH();
  }
  if (!doiTuong || doiTuong === null) {
    getDoiTuong();
  }
  if (!nguonBN) {
    fetchSourcePatient();
  }
  if (!TTTraThuoc) {
    getListTrangThaiTraThuoc();
  }
  if (!loaiKCB) {
    getListLoaiKCB();
  }
  if (!tenDoan) {
    getLitGroup();
  }

  if (!tenPhong) {
    getListBuongSo();
  }

  if (!tenGiuong) {
    getListDanhMucGiuongBenh();
  }
};

export default CheckNullApi;
